module.exports = __webpack_public_path__ + "static/media/small-heart-icon.81ec6e55.svg";